export class ForgotId{
    constructor(
        public email:any,
        public corpCode:any,
        public appName:any,
    ){
    }
}